import React         from 'react';
import ReactDom      from 'react-dom';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from 'contents_modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class InfluencerActions extends React.Component {
  render() {
    let data = this.props.data;
    let base = this.props.base;
    if( base == undefined ) base = { workflow: {}, event: {} };
    
    if( data.is_not_import_action === true ) return null;
    
    // メンバー設定
    let members = ( this.props.base.multi_select == undefined ) ? [] : this.props.base.multi_select.concat();
    if( members.indexOf(data.insta_user_id) == -1 ) members.push(data.insta_user_id);
    members = members.filter((id) => { if( id != undefined && id != null && id != '' ) return id; });
    
    // ワークフロー画面
    let mode = base.mode;
    if( mode == 'workflow' ){
      return <InfluencerWorkflowActions data={data} base={base} members={members} />
    }
    
    // 検索画面
    return <InfluencerSearchActions data={data} base={base} members={members} refresh_ev={this.props.refresh_ev.bind(this)} />
  }
}
// -------------------------------------------------------

class InfluencerWorkflowActions extends React.Component {
  render() {
    let data = this.props.data;
    let base = this.props.base;
    let members = this.props.members;
    
    let workflow = base.workflow;
    let event = base.event;
    
    let is_active = false;
    let is_deleted = false;
    try { is_active = (workflow.influencers[data.insta_user_id] != undefined); } catch(e){}
    try { workflow.items.candidate.map((d) => { if( d.insta_user_id == data.insta_user_id ) is_deleted = true; }); } catch(e){}
    try { workflow.items.stock.map((d) => { if( d.insta_user_id == data.insta_user_id ) is_deleted = true; });} catch(e){}
    
    // 一括削除
    if( data.multi_select_mode == 'deleted' ){
      is_active = true;
      is_deleted = true;
    }
    
    return (
      <div className="influencer-actions">
        { (is_active == true ) &&
          <div className="action-single">
            { (is_deleted == true)
              ? <div className="button no" onClick={event.select_ev.bind(this, data.insta_user_id, 'delete')}>候補者から外す{(members.length >= 2) && ' ('+ members.length +')'}</div>
              : <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>この操作には、「ストック・候補者」のグループである必要があります</Tooltip>}>
                  <div className="button no off">候補者から外す</div>
                </OverlayTrigger>
            }
          </div>
        }
        { (is_active == false ) &&
          <div className="action-multi">
            <div className="button" onClick={event.select_ev.bind(this, data.insta_user_id, 'candidate')}>候補者に追加する{(members.length >= 2) && ' ('+ members.length +')'}</div>
            <div className="button no" onClick={event.select_ev.bind(this, data.insta_user_id, 'stock')}>ストックする{(members.length >= 2) && ' ('+ members.length +')'}</div>
          </div>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

class InfluencerSearchActions extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal     : false,
      is_active : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * モーダル操作
   */
  toggleModal(flg) {
    this.setState({ modal: flg });
  }
  // -------------------------------------------------------
  
  /*
   * モーダル操作
   */
  change(mode) {
    this.setState({ is_active: (this.project_id.value != 'none') });
  }
  // -------------------------------------------------------
  
  /*
   * モーダル操作
   */
  select(progress) {
    let data = this.props.data;
    
    let project_id = this.project_id.value;
    if( project_id == 'none' ) return;
    
    // メンバー設定
    let members = this.props.base.multi_select;
    if( members == undefined ) members = [];
    
    if( members.indexOf(data.insta_user_id) == -1 ) members.push(data.insta_user_id);
    
    Utils.request.bind(this)('/api/project/workflow/addition_influencer', { members: members, project_id: project_id, progress: progress },
      function(res){
        this.props.refresh_ev.bind(this)();
        this.props.base.event.updateData.bind(this)('multi_select', []);
        
        alert('プロジェクトに追加しました！');
        this.setState({ modal: false });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let base = this.props.base;
    let members = this.props.members;
    
    let workflow = base.workflow;
    let event = base.event;
    
    return (
      <div className="influencer-actions">
        <div className="action-project">
          <div className="button" onClick={this.toggleModal.bind(this)}>プロジェクトに追加する{(members.length >= 2) && ' ('+ members.length +')'}</div>
        </div>
        
        <div className="add-project-modal">
          <ContentsModal
            view      = {this.state.modal}
            width     = {400}
            height    = {175}
            close_ev  = {this.toggleModal.bind(this, false)}
            html      = {
              <div className="modal-item">
                <h2>追加したいプロジェクトを選択してください</h2>
                
                <div className="selectbox">
                  <select ref={(input) => { this.project_id = input }} onChange={this.change.bind(this)}>
                    <option value={'none'}>プロジェクトを選択</option>
                    { data.projects_active.map((d, key) => {
                      if( d.progress != null ){
                        return <option key={key} disabled>{d.title} (選択済み)</option>
                      } else {
                        return <option key={key} value={d.id}>{d.title}</option>
                      }
                     })}
                  </select>
                </div>
                
                { (this.state.is_active == true)
                  ? <div className="action-multi">
                      <div className="button" onClick={this.select.bind(this, 'candidate')}>候補者に追加する</div>
                      <div className="button no" onClick={this.select.bind(this, 'stock')}>ストックする</div>
                    </div>
                  : <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>プロジェクトを選択してください</Tooltip>}>
                      <div className="action-multi">
                        <div className="button off">候補者に追加する</div>
                        <div className="button no off">ストックする</div>
                      </div>
                    </OverlayTrigger>
                }
              </div>
            }
          />
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerActions;